import React from 'react';

const CostHeadCalculation = ({ data }) => {
    let total = 0;
    return (
        <table className="mt-5 mb-5 br-5" border={1}>
            <tr>
                <th>Cost Heading</th>
                <th>UOM</th>
                <th>Chargable Wt</th>
                <th><span className="ml-5">Price</span></th>
                <th>Total</th>
            </tr>
            {(data || []).map((cost, costIndex) => {
                total = total + Number(cost.headingChargesBusinessVolumeUnit === 'Per Shipment' ? cost.headingChargesCp_inr : (cost.headingChargesCp_inr * cost.headingChargesBusinessVolumeValue).toFixed(2));
            return(<tr>
                <td>{cost.headingChargesValue}</td>
                <td><span className="ml-5">{cost.headingChargesBusinessVolumeUnitName}</span></td>
                <td><div className="ml-5 tCenter">{cost.headingChargesBusinessVolumeValue}</div></td>
                <td><span className="ml-5">{cost.headingChargesCp_inr && Number(cost.headingChargesCp_inr).toFixed(2)}</span></td>
                <td><span className="ml-5">{cost.headingChargesBusinessVolumeUnit === 'Per Shipment' ? cost.headingChargesCp_inr : (cost.headingChargesCp_inr * cost.headingChargesBusinessVolumeValue).toFixed(2)}</span></td>
            </tr>)})}
            <tr>
                <td colSpan="4"><div className="tCenter">Total</div></td>
                <td><span className="ml-5">{total && Number(total).toFixed(2)}</span></td>
            </tr>
       </table>
    )
}

export default CostHeadCalculation;